import { required } from "vuelidate/lib/validators";

const sendinvite = {
  data() {
    return {

      sendinviteData: {
        Message: "Arkadaşınız Sizi Mezun Bilgi Sistemini Kullanmaya Davet Ediyor...  Bağlantı >>> " + this.$config.URL,
        Recievermailadress: null
      },
      FormDataType: {
        Message: { FieldName: "Message", Field: "input", FieldTitle: this.$t('sendinvite.AddEdit.Message'), FieldType: "text" },
        Recievermailadress: { FieldName: "Recievermailadress", Field: "textarea", FieldTitle: this.$t('sendinvite.AddEdit.Recievermailadress') },
      }
    }
  },
  validations: {
    FormData: {
      Message: { required },
      Recievermailadress: { required }
    }

  },



}
export default sendinvite